import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core'

import * as fromUserStore from '@app/users/store'

import { Store } from '@ngrx/store'
import * as fromSidebarStore from '@app/sidebar/store'
import { Observable } from 'rxjs'
import { User } from '@app/shared/models'
import { map, tap } from 'rxjs/operators'
import { FOLLOW_UP_RESOURCE } from '@app/shared/models'
import moment from 'moment'

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SideBarMenuComponent implements OnInit {
  @Input()
  set isActive(val) {
    this.options.isActiveSidebar = val || false
    if (!this.options.isActiveSidebar) {
      this.store.dispatch(new fromSidebarStore.GetScheduleEvents({ short: true }))
    }
  }
  @Output()
  onNavMobileClose = new EventEmitter<void>()
  @Output()
  onActiveMenu = new EventEmitter<boolean>()
  @Input()
  type: string
  @Input()
  appVer
  @Input()
  options: {
    mobile?: boolean,
    isActiveSidebar?: boolean
  } = {
    isActiveSidebar: false
  }

  activeMenuTab = signal('')
  notificationsUnReadCount$: Observable<number>
  tasksUnReadCount$: Observable<number>
  currentUser$: Observable<User>
  users
  userIsCustomer = signal(false);
  isBroker = signal(false);
  unreadThreadsCount$: Observable<number>
  expiredDatesCount$: Observable<number>
  canDisplayExpirationList$: Observable<any>
  users$: Observable<User[]>
  currentUserId: string
  FOLLOW_UP_RESOURCE = FOLLOW_UP_RESOURCE

  fromSidebarStore = fromSidebarStore

  constructor(
    private store: Store<fromSidebarStore.State>,
  ) { }

  ngOnInit() {
    this.store.dispatch(new fromSidebarStore.GetScheduleEventsLive({}))
    this.store.dispatch(new fromSidebarStore.LoadSlackStatuses())

    this.notificationsUnReadCount$ = this.store.select(
      fromSidebarStore.selectUnreadedScheduleEventNotificationsCount
    )
    this.users$ = this.store.select(fromSidebarStore.selectAllUsers)
    this.unreadThreadsCount$ = this.store.select(fromSidebarStore.selectThreadsUnreadCount)
    this.expiredDatesCount$ = this.store.select(fromSidebarStore.selectExpiredExpirationsCount)
    this.currentUser$ = this.store.select(fromUserStore.getUser).pipe(
      map(u => {
        if (u?.type === "CUSTOMER") { this.userIsCustomer.set(true) }
        this.isBroker.set(u?.company?.type === 'BROKER')
        return u
      }),
      tap(user => this.currentUserId = user?._id)
    )
    this.canDisplayExpirationList$ = this.store.select(fromUserStore.getPermissions).pipe(map(p => p?.expirations_list))

    this.tasksUnReadCount$ = this.store.select(fromSidebarStore.selectAllTasksWithUnread)
      .pipe(
        map(tasks => tasks.filter(t => !t._read).length)
      )
    this.options?.mobile ? this.updateMenuActive('Notifications') : null
  }

  updateMenuActive = (tab:'Notifications' | 'My Tasks' | 'Messages' | 'Users' | 'Auto-Assignees' | 'Expirations' | 'Slack') => {
    if (this.activeMenuTab() === tab && !this.options.mobile) {
      this.onActiveMenu.emit(false)
      this.activeMenuTab.set('')
    } else {
      this.activeMenuTab.set(tab)
      // The notifications list loads its own paginated page on init
      if (this.activeMenuTab() !== 'Notifications') {
        this.store.dispatch(new fromSidebarStore.GetScheduleEvents({ short: true }))
      }
      this.onActiveMenu.emit(true)
    }
  }

  dateFromNow(date: string): 'green' | 'yellow' | 'red' {

    const now = moment.utc().startOf('day');
    const created = moment.utc(date).startOf('day');
    const diffDays = created.diff(now, 'days');

      return diffDays <= 1 ? 'red' : diffDays <= 3 ? 'yellow' : 'green';
  }

  ringCentralSpinning: boolean = false

  openRingCentral() {
    this.ringCentralSpinning = true
    this.store.dispatch(
      new fromUserStore.GetOAuthRedirectUrl({
        platform: 'ring-central',
        accountId: this.currentUserId
      })
    )
  }
}
